export default "./images/WD75.jpg";